module.exports = __webpack_public_path__ + "static/media/63pic.633223cf.jpg";